import { Placement } from '@popperjs/core';

export type DropdownMenuPropsModel = {
  tooltipChildren?: {
    element: JSX.Element | null;
    placement: 'top' | 'bottom';
  };
  buttonClassName?: string;
  dropdownClassName?: string;
  dropdownIconClassName?: string;
  dropdownTooltipClassName?: string;
  dropdownArrowClassName?: string;
  dropdownTooltipXOffset?: any;
  dropdownTooltipYOffset?: any;
  showArrow?: boolean;
  arrowPosition?: 'left' | 'right';
  dropdownItems:
    | (JSX.Element | string | NestedMenuModel)[]
    | (JSX.Element | NestedMenuModel)[];
  dropdownItemsData?: any[];
  dropdownItemsComponents?: any[];
  setDropdownAsStatic?: boolean;
  isDropdownVisible?: boolean;
  isDropdownDisabled?: boolean;
  handleClick?: (item: string, data: any, key: string) => any;
  hideOnItemClick?: boolean;
  hideOnOutsideClick?: boolean;
  hideOnMouse?: boolean;
  disableCursorOverride?: boolean;
  children?: any;
  placement?: Placement;
  isNested?: boolean;
  onClose?: () => any;
  onOpen?: () => any;
};

export interface NestedMenuModel {
  item: string | JSX.Element;
  key?: string;
  withBorder?: boolean;
  dropdownItems?: DropdownMenuPropsModel['dropdownItems'];
  // dropdownItems?: (string | NestedMenuModel)[] | JSX.Element[]
  dropdownItemsData?: any[];
  handleClick?: DropdownMenuPropsModel['handleClick'];
  tooltipChildren?: DropdownMenuPropsModel['tooltipChildren'];
  hideItemOnClick?: DropdownMenuPropsModel['hideOnItemClick'];
}

export const isNestedMenu = (
  arg: DropdownMenuPropsModel['dropdownItems'][number]
) => {
  return (
    typeof arg === 'object' &&
    'dropdownItems' in arg &&
    arg.dropdownItems &&
    arg.dropdownItems.length > 0
  );
};

// export const isNestedMenu = (arg: string | NestedMenuModel): arg is NestedMenuModel => {
//   return typeof arg === 'object' && 'item' in arg && 'dropdownItems' in arg;
// }
